const paymentSk = {
    "billing": {
        "name": "Meno/Názov spoločnosti",
        "country": "Krajina",
        "postal_code": "Poštové smerovacie číslo",
        "city": "Mesto",
        "address": "Adresa",
        "tax_number": "Daňové číslo",
        "phone": "Telefónne číslo",
        "tax_number_helper_text": "Povinné pre firmy, nie pre jednotlivcov",
        "billing_info": "Fakturačné informácie",
        "emails_helper_text": "Voliteľné. Ak máte viacero e-mailových adries, oddeľte ich čiarkami."
    },
    "subscription_plans": {
        "PRO": "Profesionálny plán",
        "FREE": "Bezplatný plán"
    },
    "plan_descriptions": {
        "PRO": "Pre reštaurácie, ktoré chcú posunúť svoje podnikanie na vyššiu úroveň! Preložte si jedálny lístok do nových jazykov len niekoľkými kliknutiami, požiadajte hostí o spätnú väzbu k ich jedlám, sledujte používanie menu pomocou QR kódu pomocou užitočných štatistík alebo nechajte QuickPick AI automaticky reagovať na spätnú väzbu od hostí vo vašom štýle!",
        "FREE": "Pre reštaurácie, ktoré chcú začať s online menu a QR kódmi."
    },
    "subscription_status": {
        "ACTIVE": "Aktívne",
        "CANCELLED": "Zrušené"
    },
    "next_billing_date": "Ďalší dátum fakturácie",
    "current_subscription": "Aktuálne predplatné",
    "cancel": "Zrušiť",
    "subscription_interval_prices": {
        "MONTHLY": "mesiac",
        "YEARLY": "rok",
        "HALF_YEARLY": "pol roka",
        "QUARTERLY": "štvrťrok"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Mesačné predplatné",
        "YEARLY": "Ročné predplatné",
        "HALF_YEARLY": "Polročné predplatné",
        "QUARTERLY": "Štvrťročné predplatné"
    },
    "reactivate": "Znovu aktivovať",
    "valid_to": "Platné do",
    "payments_and_invoices": "Platby a faktúry",
    "amount": "Suma",
    "invoice": "Faktúra",
    "update_card": "Aktualizácia",
    "payment_method": "Spôsob platby",
    "cancel_subscription_confirmation": "Naozaj chcete zrušiť svoje aktuálne predplatné?",
    "cancel_subscription_valid_until": "Predplatné do dátumu uvedeného nižšie zostane platné do nasledujúceho dátumu.",
    "subscription_cancelled": "Predplatné bolo úspešne zrušené",
    "reactivate_confirmation": "Naozaj chcete znova aktivovať zrušené predplatné?",
    "reactivate_successful": "Predplatné bolo úspešne obnovené",
    "change_payment_method": "Zmeniť spôsob platby",
    "change_payment_method_tooltip": "Ak chcete zmeniť svoje platobné údaje, musíte zaplatiť za ďalšie obdobie predplatného. Vaše predplatné sa samozrejme predĺži o dĺžku obdobia a ďalší dátum fakturácie bude splatný o rovnaký čas neskôr.",
    "amount_to_be_paid": "Suma k úhrade",
    "new_subscription_valid_until": "Platnosť nového predplatného",
    "bank_card_expires_soon": "Platnosť bankovej karty použitej na predplatné čoskoro vyprší.",
    "reactivate_subscription_confirmation": "Naozaj chcete znova aktivovať zrušené predplatné?",
    "billing_information": "Fakturačné informácie",
    "edit_billing_information": "Upraviť fakturačné informácie",
    "no_available_invoices": "Nie sú k dispozícii žiadne faktúry",
    "subscribe": "Prihlásiť sa na odber",
    "continue_to_payment": "Pokračovať k platbe",
    "confirm_subscription": "Potvrdiť odber",
    "subscription_page_title": "Spustiť predplatné",
    "pay": "Platba",
    "available_plans": "Dostupné predplatné",
    "accept_terms_and_conditions": "Prečítal(a) som si a súhlasím so <a>Zmluvnými podmienkami</a>",
    "accept_recurring_payments": "Platbou súhlasím s automatickým účtovaním opakujúcich sa platieb, ktoré môžem kedykoľvek zrušiť.",
    "accept_privacy_policy": "Prečítal(a) som si a súhlasím so <a>Zásadami ochrany osobných údajov</a>",
    "subscribe_soon": "Čoskoro"
};

export default paymentSk;
